/**
 * Class to load Script EarlyBirds dynamically
 */
export default class LoadEarlyBirdsChunk {
  private readonly body: HTMLElement;

  constructor() {
    this.body = document.querySelector('body');

    if (!this.body.classList.contains('js-eventEarlyBirds--processed')) {
      /* Load Add to Cart popin's CSS and JS */
      import(
        /* webpackPrefetch: true */
        /* webpackChunkName: 'prefetch-earlybirds' */
        '../../../components/EarlyBirds/EarlyBirds'
      ).then(({ default: EarlyBirds }) => {
        const body: HTMLElement = document.querySelector('body');
        const injectSliderEbProductBlocs: NodeListOf<HTMLElement> =
          document.querySelectorAll('.js-replaceByEbSlider');

        // Replace element in page exist
        if (
          injectSliderEbProductBlocs.length > 0 &&
          !body.classList.contains('js-eventEarlyBirds--processed')
        ) {
          const earlyBirds = new EarlyBirds();
          earlyBirds.initEarlybirds(injectSliderEbProductBlocs, body);

          // Block multiple injection
          body.classList.add('js-eventEarlyBirds--processed');
        }
      });
    }
  }
}
